<template>
  <div id="app" class="app">
    <router-view/>
  </div>
</template>

<script>
  import ax from './axios/ax'
  export default {
    name: 'app',
    beforeMount () {
      if (!this.$jwt.hasToken()) {
        this.$router.push({ name: 'login' })
      }
      ax.loginCheck(this.$jwt.getToken(), this)
    }
  }
</script>

<style lang="scss">
  @import "sass/main";

  body {
    height: 100%;
    #app {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue